// API Configuration
// Centralizes all API endpoints and URLs

const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:8787/api';
    }
  }
  return 'https://biig-api.b-9f2.workers.dev/api';
};

export const API_CONFIG = {
  // Base URLs - dynamically determined based on current host
  API_URL: getApiBaseUrl(),
    
  FILES_URL: import.meta.env.DEV
    ? (import.meta.env.VITE_FILES_URL || 'http://localhost:8788')
    : 'https://biig-api.b-9f2.workers.dev',

  // API Endpoints
  endpoints: {
    // Auth
    login: '/login',
    verifyToken: '/verify-token',
    
    // Users
    users: '/users',
    
    // AI
    ai: {
      generate: '/ai/generate',
      analyzeUser: '/ai/analyze-user',
      models: '/ai/models'
    }
  }
};

// Helper to build full URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.API_URL}${endpoint}`;
};

export const buildFilesUrl = (path: string): string => {
  return `${API_CONFIG.FILES_URL}${path}`;
};